const pagesItemLedgerEn = {
  actionAdd: 'Add Item',
  actionAddProcurementProfile: 'Add Procurement Profile',
  actionAddSalesProfile: 'Add Sales Profile',
  actionCancel: 'Cancel',
  actionChangeStatus: 'Change Status',
  actionEdit: 'Edit',
  actionGoToItemDetail: 'Go to Details',
  actionSave: 'Save',
  addPageTitle: 'Add Item',
  boolNo: 'No',
  boolYes: 'Yes',
  changeStatusDialogTitle: 'Change Status',
  changeStatusReasonPlaceholder: 'Reason (optional)',
  completedByLabel: 'Completed by:',
  completedMessage: 'Item added.',
  completedTitle: 'Result',
  continueAdding: 'Continue adding another item',
  detailPageTitle: 'Item Detail',
  editDialogTitle: 'Edit Item',
  fieldBaseUnit: 'Base Unit',
  fieldCurrency: 'Currency',
  fieldCustomsClearanceDays: 'Customs Clearance (days)',
  fieldDeliveryMultiple: 'Delivery Multiple',
  fieldDescription: 'Internal Memo',
  fieldGrProcessingDays: 'GR Processing (days)',
  fieldIsDiscountAllowed: 'Discount Allowed',
  fieldIsReturnable: 'Returnable',
  fieldItemType: 'Item Type',
  fieldLeadTimeDays: 'Lead Time (days)',
  fieldMaxDiscountPct: 'Max Discount (%)',
  fieldMaxOrderQty: 'Max Order Qty',
  fieldMinDeliveryQty: 'Min Delivery Qty',
  fieldMinOrderQty: 'Min Order Qty',
  fieldMinSalesQty: 'Min Sales Qty',
  fieldName: 'Name',
  fieldOrderMultiple: 'Order Multiple',
  fieldProfileStatus: 'Status',
  fieldPurchasingLeadDays: 'Purchasing Lead (days)',
  fieldSafetyLeadDays: 'Safety Lead (days)',
  fieldSalesLeadTimeDays: 'Sales Lead Time (days)',
  fieldSalesPrice: 'Standard Sales Price',
  fieldStandardPrice: 'Standard Price',
  fieldTargetStatus: 'Target Status',
  fieldTaxRatePct: 'Tax Rate (%)',
  fieldTransportationDays: 'Transportation (days)',
  itemStatus: {
    ACTIVE: 'Active',
    ARCHIVED: 'Archived',
    BLOCKED: 'Blocked',
    DRAFT: 'Draft',
    OBSOLETE: 'Obsolete'
  },
  itemTypeOption: {
    FERT: 'Finished',
    FOOD: 'Food',
    HALB: 'Semi-finished',
    HAWA: 'Merchandise',
    ROH: 'Raw Material'
  },
  listFilterAll: 'All',
  listFilterPlaceholder: 'Search by item number or name...',
  listFilterType: 'Item Type',
  listPageTabAlert: 'Alert',
  listPageTabBom: 'Bom',
  listPageTabDealModeView: 'DealModeView',
  listPageTabItemList: 'ItemList',
  listPageTabOperationActivity: 'Operation & Activity',
  listPageTabOverview: 'Overview',
  listPageTabRulePolicy: 'Rule & Policy',
  listPageTabSetting: 'Setting',
  listPageTitle: 'Item',
  procurementNotSet: 'Procurement profile not configured',
  procurementProfileCreateTitle: 'Add Procurement Profile',
  procurementProfileEditTitle: 'Edit Procurement Profile',
  profileStatus: {
    ACTIVE: 'Active',
    DISCONTINUED: 'Discontinued',
    DRAFT: 'Draft',
    SUSPENDED: 'Suspended'
  },
  profileStatusChangeTitle: 'Change Profile Status',
  progressFilledLabel: 'Filled',
  progressRequiredLabel: 'Required Fields',
  progressTotalLabel: 'All Fields',
  salesNotSet: 'Sales profile not set',
  salesProfileCreateTitle: 'Add Sales Profile',
  salesProfileEditTitle: 'Edit Sales Profile',
  sectionIdentity: 'Identity',
  sectionProcurement: 'Procurement Profile',
  sectionSales: 'Sales Profile',
  selectPlaceholder: 'Please select'
};
export default pagesItemLedgerEn;